import React, { Component } from "react";
import { Link } from "react-router-dom";

import RegHold from "../components/registrationHolds";
import Transcript from "../components/transcripts";
import Immunization from "../components/immunization";
import I20 from "../components/I20";
import TAship from "../components/TAship";
import RAship from "../components/RAship";
import Apartment from "../components/apartment";
import OffCampusGuide from "../components/OffCampusGuide";
import StudentOrientation from "../components/studentOrientation";
// import Visa from "../components/visa";

export default class postAdmissionPages extends Component {
  getPageDetails = (pageName) => {
    let pageDetail = null;
    switch (pageName) {
      case "registration_holds":
        pageDetail = { breadCrumb: "Registration Holds", heading: "REGISTRATION HOLDS", component: <RegHold /> };
        break;
      case "transcripts":
        pageDetail = { breadCrumb: "Transcripts", heading: "Transcripts", component: <Transcript /> };
        break;
      case "immunization":
        pageDetail = { breadCrumb: "Immunization", heading: "IMMUNIZATION", component: <Immunization /> };
        break;
      case "I20_process":
        pageDetail = { breadCrumb: "I20 Process", heading: "I20 Process", component: <I20 /> };
        break;
      case "TAship":
        pageDetail = { breadCrumb: "TA ship", heading: "TEACHING ASSISTANCESHIP", component: <TAship /> };
        break;
      case "RAship":
        pageDetail = { breadCrumb: "RA ship", heading: "RESEARCH ASSISTANCESHIP", component: <RAship /> };
        break;
      case "apartments":
        pageDetail = { breadCrumb: "Apartments", heading: "Apartments and Accomodations", component: <Apartment /> };
        break;
      case "offCampusGuide":
        pageDetail = { breadCrumb: "Off Campus Housing Guide", heading: "Off Campus Housing", component: <OffCampusGuide /> };
        break;
      case "student_orientation":
        pageDetail = { breadCrumb: "Student Orientation", heading: "Student Orientation", component: <StudentOrientation /> };
        break;
      // case "VISA":
      //   pageDetail = { breadCrumb: "VISA", heading: "VISA Process", component: <Visa /> };
      //   break;

      default:
        pageDetail = { breadCrumb: "Page Not Found", heading: "404 Page Not Found" };
        break;
    }
    return pageDetail;
  };

  constructor(props) {
    super(props);
    let urlArr = window.location.href.split("/");
    let pageDetail = this.getPageDetails(urlArr[urlArr.length - 1]);
    this.state = { ...pageDetail };
  }

  render() {
    return (
      <React.Fragment>
        <div className="container">
          <br />
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={"/"}>Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to={"/postAdmission"}>Post Admission</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {this.state.breadCrumb}
              </li>
            </ol>
          </nav>
        </div>
        <div className="container">
          <span className="welcome_text">{this.state.heading}</span>
          <hr />
          {this.state.component}
        </div>
      </React.Fragment>
    );
  }
}
